import { Collapse, Divider } from "antd";
import {
	SubmitButtonOverlay,
	ActionContainer,
	ActionItemsContainer,
} from "../../components/styled/common";
import { DocCategoryItems } from "./constants";
import CollapseExpandIcon from "../../components/CollapseExpandIcon";
import MainButtonComponent from "../../components/MainButtonComponent";
import { useDocCategoryContext } from "../../context/DocumentCategoryContext/DocumentCategoryContext";

const AddDocumentCategory = () => {
	const { addDocCategory, operationStatus } = useDocCategoryContext();

	return (
		<ActionContainer>
			<ActionItemsContainer>
				<h3>Yeni Kategori Ekleme</h3>
				<Divider />
				<Collapse
					items={DocCategoryItems}
					expandIconPosition="end"
					bordered={false}
					ghost
					expandIcon={CollapseExpandIcon}
					defaultActiveKey={["1"]}
				/>
				<SubmitButtonOverlay>
					<MainButtonComponent onClick={addDocCategory} loading={operationStatus.type === "loading" && operationStatus.operation === "add"}>
						Kategoriyi Ekle
					</MainButtonComponent>
				</SubmitButtonOverlay>
			</ActionItemsContainer>
		</ActionContainer>
	);
};

export default AddDocumentCategory;
